import { rem } from "polished";
import * as React from "react";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

const ResponsiveSVG = withViewportStyle("svg")`
  height: ${rem(100)};
  width: ${rem(100)};

  ${(props) => props.$viewport.tablet`
    height: ${rem(70)};
    width: ${rem(70)};
  `}

  ${(props) => props.$viewport.mobile`
    height: ${rem(40)};
    width: ${rem(40)};
  `}
`;

export const OneQuarterCircle = () => {
  return (
    <ResponsiveSVG
      className="one-quarter-circle"
      data-testid="one-quarter-circle-vector"
      viewBox="0 0 100 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M-8.74228e-06 200C26.5216 200 51.957 189.464 70.7107 170.711C89.4643 151.957 100 126.522 100 100C100 73.4784 89.4643 48.043 70.7107 29.2893C51.957 10.5357 26.5217 7.92818e-07 1.52588e-05 -4.37114e-06L-4.37114e-06 100L-8.74228e-06 200Z" />
    </ResponsiveSVG>
  );
};
